import $ from 'jquery'

/**
 * Show and hide things by using a class called `hidden`.
 * Make sure you have something like this in your SASS/CSS:
 *   .hidden
 *     display: none !important
 */
($ => {
  $.fn.toggleVisibility = function (condition) {
    return $(this).toggleClass('hidden', !condition)
  }
})($)
